module.exports = __webpack_public_path__ + "static/media/usage_toy.8de3c6ca.png";